import React, { FC } from 'react';

import CollapseArrow from '../CollapseArrow';
import Collapsable, { CollapsableProps } from '../Collapsable';
import { StyledContent, StyledButton } from './Collapse.styles';

export interface CollapseProps extends CollapsableProps {
  /** The title of the collapse */
  title: string;
  /** Use a smaller version for the collapse. */
  small?: boolean;
  /** Use a large version for the collapse. */
  large?: boolean;
  /** Style the background in white. */
  white?: boolean;
  /** Style a shadow for the collapse. */
  boxShadow?: boolean;
  /** Number of pixels for the collapse border radius. */
  borderRadius?: number;
  /** if true, no padding applied to the content */
  noContentPadding?: boolean;
  /** if true, no padding applied to the header */
  noTargetPadding?: boolean;
  /** Value of the font weight for the header */
  targetFontWeight?: number;
  /** Style the background in white */
  whiteBackground?: boolean;
  /** Value of the margin for the header */
  targetMargin?: string;
}

const Collapse: FC<CollapseProps> = ({
  children, title, small, large, white, boxShadow, borderRadius, noContentPadding, whiteBackground, noTargetPadding, targetFontWeight, targetMargin, ...props
}) => (
  <Collapsable data-testid="Collapse" headerAs="h3" {...props}>
    <Collapsable.Target>
      {({ isCollapsed, toggle }) => (
        <StyledButton
          white={white}
          boxShadow={boxShadow}
          borderRadius={borderRadius}
          isCollapsed={isCollapsed}
          whiteBackground={whiteBackground}
          type="button"
          small={small}
          large={large}
          onClick={toggle}
          noTargetPadding={noTargetPadding}
          targetFontWeight={targetFontWeight}
          targetMargin={targetMargin}
        >
          <CollapseArrow
            isCollapsed={isCollapsed}
            small={small}
            large={large}
          />
          {title}
        </StyledButton>
      )}
    </Collapsable.Target>
    <Collapsable.Content>
      <StyledContent
        small={small}
        noContentPadding={noContentPadding}
      >
        {children}
      </StyledContent>
    </Collapsable.Content>
  </Collapsable>
);

export default Collapse;
